export const options = [{
    label: '语文',
    options: [
    {
        value: '1/66',
        label: '小学'
    }, {
        value: '1/77',
        label: '初中'
    }, {
        value: '1/88',
        label: '高中'
    }]
}, {
    label: '数学',
    options: [
    {
        value: '2/66',
        label: '小学'
    }, {
        value: '2/77',
        label: '初中'
    }, {
        value: '2/88',
        label: '高中'
    }]
}, {
    label: '英语',
    options: [
    {
        value: '3/66',
        label: '小学'
    }, {
        value: '3/77',
        label: '初中'
    }, {
        value: '3/88',
        label: '高中'
    }]
}, {
    label: '物理',
    options: [
    {
        value: '4/77',
        label: '初中'
    }, {
        value: '4/88',
        label: '高中'
    }, {
        value: '4/10',
        label: '必修'
    }, {
        value: '4/11',
        label: '选修'
    }]
}, {
    label: '化学',
    options: [
    {
        value: '5/77',
        label: '初中'
    }, {
        value: '5/88',
        label: '高中'
    }, {
        value: '5/10',
        label: '必修'
    }]
}, {
    label: '生物',
    options: [
    {
        value: '6/77',
        label: '初中'
    }, {
        value: '6/88',
        label: '高中'
    }]
}, {
    label: '地理',
    options: [
    {
        value: '7/77',
        label: '初中'
    }, {
        value: '7/88',
        label: '高中'
    }]
}, {
    label: '历史',
    options: [
    {
        value: '8/77',
        label: '初中'
    }, {
        value: '8/88',
        label: '高中'
    }]
}, {
    label: '政治',
    options: [
    {
        value: '9/77',
        label: '初中'
    }, {
        value: '9/88',
        label: '高中'
    }]
}
// , {
//     label: '奥数',
//     options: [
//     {
//         value: '10/77',
//         label: '初中'
//     }, {
//         value: '10/88',
//         label: '高中'
//     }]
// }, {
//     label: '新概念',
//     options: [
//     {
//         value: '11/77',
//         label: '初中'
//     }, {
//         value: '11/88',
//         label: '高中'
//     }]
// }
]
